module.exports = __webpack_public_path__ + "static/img/pic1.1.83e2e62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic1.1.png
// module id = FrFI
// module chunks = 0